export enum StatsPeriod {
  Day = 'day',
  Month = 'month',
  Unknown = 'unknown',
}

export interface Subscription {
  planId: string;
  startDate: string;
  endDate?: string;
  emailSendingCreditsUsed: number;
  emailSendingUsagePeriod: StatsPeriod;
  downgradePlanId?: string;
  downgradePlanStartDate?: string;
  downgradePlanEndDate?: string;
}
